import {createSelector} from 'reselect';
const selectRooms = (state) => state.rooms;

const makeSelectRoomsData = () => createSelector(selectRooms, (roomsState) => roomsState.roomsData);

const makeSelectRoomProfile = () => createSelector(selectRooms, (roomsState) => roomsState.roomProfile);

export {makeSelectRoomsData, makeSelectRoomProfile};
